<template>
  <div
    :class="[
      'flex-1 flex items-center justify-center gap-2 h-44 px-2 rounded-14',
      isCanceling ? 'bg-#ff3838' : 'bg-#2b44ff',
    ]"
  >
    <div
      v-for="(bar, index) in bars"
      :key="index"
      class="w-3 min-h-8 rounded-4 transition-height duration-100 ease-out bg-white"
      :style="{
        height: `${bar.height}%`,
      }"
    ></div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";

const props = defineProps({
  isCanceling: {
    type: Boolean,
    default: false,
  },
  audioLevel: {
    type: Number,
    default: 0,
    validator: (value) => value >= 0 && value <= 1,
  },
  barCount: {
    type: Number,
    default: 40,
  },
  minHeight: {
    type: Number,
    default: 20,
  },
  maxHeight: {
    type: Number,
    default: 44,
  },
});

const bars = ref([]);

// 初始化音频条
const initBars = () => {
  bars.value = Array(props.barCount)
    .fill(0)
    .map(() => ({
      height: props.minHeight,
      targetHeight: props.minHeight,
    }));
};

// 更新音频条高度
const updateBars = () => {
  const activeBars = Math.max(1, Math.floor(props.barCount * props.audioLevel));
  const barIndices = Array.from({ length: props.barCount }, (_, i) => i)
    .sort(() => Math.random() - 0.5)
    .slice(0, activeBars);

  bars.value.forEach((bar, index) => {
    if (barIndices.includes(index)) {
      const randomFactor = 0.7 + Math.random() * 0.3;
      bar.targetHeight =
        props.minHeight +
        (props.maxHeight - props.minHeight) * props.audioLevel * randomFactor;
    } else {
      bar.targetHeight = Math.max(props.minHeight, bar.targetHeight * 0.7);
    }
  });
};

// 平滑动画
const animateBars = () => {
  bars.value.forEach((bar) => {
    bar.height = bar.height * 0.6 + bar.targetHeight * 0.4;
  });
  requestAnimationFrame(animateBars);
};

watch(() => props.audioLevel, updateBars);

onMounted(() => {
  initBars();
  animateBars();
});
</script>
